import React from "react";
import { Hidden } from "@material-ui/core";

import PhoneDesktop from "./Desktop";
import PhoneMobile from "./Mobile";

const Phone = () => {

  return (
    <>
      <Hidden xsDown>
        <PhoneDesktop />
      </Hidden>

      <Hidden smUp>
        <PhoneMobile />
      </Hidden>
    </>
  );
};

export default Phone;
